/**
 * Open a plugin-supplied URL safely. Plugins are third-party; the `open-url`
 * action must never be able to trigger navigation to `javascript:`, `data:`,
 * `blob:`, `file:` or other non-web schemes. Only http/https are allowed, and
 * we open with `noopener,noreferrer` so the opened page can't reach back.
 */
export function openPluginUrl(raw: unknown): void {
  if (typeof raw !== "string" || !raw) return;
  let u: URL;
  try {
    u = new URL(raw);
  } catch {
    return;
  }
  if (u.protocol !== "https:" && u.protocol !== "http:") return;
  window.open(u.href, "_blank", "noopener,noreferrer");
}
